<template>
  <div class="mt-2">
    <form @submit.prevent="fetchPage">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-book"></i> Buscar
          Ssv 2300 Confi Opeda Ws
        </div>
        <div class="card-body">
          <div class="row">

            <div class="form-group col-sm-12 mb-0 text-right">
              <router-link :to="{ name: 'ssv2300-confi-opeda-ws-new'}">
                <b-button size="sm" class="btn-sm btn btn-sm mr-1" variant="success" title="Novo"> <i class="fa fa-floppy-o"></i> Novo </b-button>
              </router-link>

              <button class="btn btn-sm btn-outline-danger" type="button" @click="cleanFilterForm()" data-toggle="tooltip" data-placement="bottom" title="Limpar">
                <i class="fa fa-eraser"></i> Limpar
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="card mt-2">
      <div class="card-header">
        <i class="fa fa-align-justify"></i> Itens registrados
      </div>
      <div class="card-body">
        <b-table :items="fetchPage" :current-page="pageNumber" per-page="20" :fields="fields" class="table table-responsive-sm table-striped" :filter="ssv2300ConfiOpedaWsFilters" filter-debounce="500" :show-empty="paginatedSsv2300ConfiOpedaWss.totalElements == 0" empty-text="Não foram encontrados registros." empty-filtered-text="Não foram encontrados registros."> <template v-slot:cell(actions)="row">
            <router-link :to="{ name: 'ssv2300-confi-opeda-ws-edit', params: { id: row.item.cdOpeda }}">

              <button class="mr-2 shadow cursor_table btn btn-outline-dark btn-sm" type="button" aria-pressed="true" title="Editar" v-b-tooltip.hover>
                <i class="fa fa-edit"></i>
              </button>
            </router-link>
          </template> </b-table>

        <b-pagination size="md" v-model="pageNumber" class="pull-right" :total-rows="paginatedSsv2300ConfiOpedaWss.totalElements" :per-page="paginatedSsv2300ConfiOpedaWss.size"> </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  
  import { 
  	FETCH_PAGINATED_SSV2300_CONFI_OPEDA_WSS, 
  	RESET_SSV2300_CONFI_OPEDA_WS_FILTERS 
  	
      } from "@/store/actions.type";
  
  export default {
    data() {
      return {
        pageNumber: 1,
        fields: [
          'actions'
        ]
      };
    },
    computed: {
      ...mapGetters(["paginatedSsv2300ConfiOpedaWss"
           ,"ssv2300ConfiOpedaWsFilters"
           
           ])
    },
    methods: {
      fetchPage(ctx) {
        return this.$store.dispatch(FETCH_PAGINATED_SSV2300_CONFI_OPEDA_WSS, {
          page: ctx.currentPage - 1,
          size: ctx.perPage,
          sort: ctx.sortBy + ',' + (ctx.sortDesc ? 'DESC' : 'ASC'),
          ...ctx.filter
        }).then(page => page.content);
      },
      cleanFilterForm () {
      	 store.dispatch(RESET_SSV2300_CONFI_OPEDA_WS_FILTERS);
    	},
    	
    },
    mounted(){
      
    },
    beforeRouteEnter(to, from, next) {
  	    store.dispatch(RESET_SSV2300_CONFI_OPEDA_WS_FILTERS);
  	    return next();
  	  }
  };
</script>